const borrowerPortalBaseUrl = process.env.UI_BORROWER_PORTAL_URL

export const borrowerPortalLoginUrl = `${borrowerPortalBaseUrl}/login`
